<div class="simmer-list">
  <div *ngFor="let item of [].constructor(count)" class="simmer-item d-flex">
    <div class="simmer-card shimmer"></div>
  </div>
</div>
